import { render, staticRenderFns } from "./CategoryDefinitions.vue?vue&type=template&id=1ca4fd80&scoped=true&"
import script from "./CategoryDefinitions.vue?vue&type=script&lang=js&"
export * from "./CategoryDefinitions.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDefinitions.vue?vue&type=style&index=0&id=1ca4fd80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4fd80",
  null
  
)

export default component.exports